import React, { useEffect, useRef, useState } from 'react';
import { HostCodesAPI } from '../../api/HostCodeEndpoints';
import './HostCodeCreation-UI.css'; // ⬅️ neues Stylesheet

export default function HostCodeCreation({ onCreated, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    instagramName: '',
    amountRedeemable: 1,
    expiresAt: '' // datetime-local
  });
  const [loading, setLoading] = useState(false);
  const [error, setError]   = useState(null);

  const dialogRef = useRef(null);
  const nameRef   = useRef(null);

  useEffect(() => {
    // Fokus auf erstes Feld + Escape schließen
    nameRef.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await HostCodesAPI.createHostCode({
        ...formData,
        // datetime-local → ISO
        expiresAt: new Date(formData.expiresAt).toISOString(),
      });
      onCreated?.();
      onClose?.();
    } catch (err) {
      console.error('Fehler beim Erstellen des Host-Codes:', err);
      setError(err.response?.status === 400
        ? 'Bitte einen gültigen Instagram-Account angeben (z. B. @flucc oder der Profil-Link).'
        : 'Host-Code konnte nicht erstellt werden.');
    } finally {
      setLoading(false);
    }
  };

  const onOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return (
    <div className="hc-modal" role="dialog" aria-modal="true" onClick={onOverlayClick}>
      <div className="hc-dialog" ref={dialogRef} onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="hc-dialog-header">
          <div className="hc-dialog-title-wrap">
            <div className="hc-dialog-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <div>
              <h3 className="hc-dialog-title">Neuer Host-Code</h3>
              <p className="hc-dialog-sub">Code erstellen und Einlösungen konfigurieren</p>
            </div>
          </div>
          <button className="hc-dialog-close" type="button" onClick={onClose} aria-label="Schließen">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round" width="16" height="16" aria-hidden="true">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>

        {error && <p className="hc-error">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="hc-form">
            <div className="hc-field">
              <label className="hc-label" htmlFor="hc-name">Name</label>
              <input
                id="hc-name"
                ref={nameRef}
                className="hc-input"
                type="text"
                value={formData.name}
                onChange={(e) => handleChange('name', e.target.value)}
                required
                placeholder="z. B. Summer Promo"
              />
            </div>

            <div className="hc-field">
              <label className="hc-label" htmlFor="hc-instagram">Instagram-Account</label>
              <input
                id="hc-instagram"
                className="hc-input"
                type="text"
                value={formData.instagramName}
                onChange={(e) => handleChange('instagramName', e.target.value)}
                required
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
                placeholder="z. B. @flucc"
              />
            </div>

            <div className="hc-row">
              <div className="hc-field">
                <label className="hc-label" htmlFor="hc-amount">Max. Einlösungen</label>
                <input
                  id="hc-amount"
                  className="hc-input"
                  type="number"
                  min="1"
                  value={formData.amountRedeemable}
                  onChange={(e) => handleChange('amountRedeemable', parseInt(e.target.value || '1', 10))}
                  required
                  placeholder="z. B. 50"
                />
              </div>

              <div className="hc-field">
                <label className="hc-label" htmlFor="hc-expires">Gültig bis</label>
                <input
                  id="hc-expires"
                  className="hc-input"
                  type="datetime-local"
                  value={formData.expiresAt}
                  onChange={(e) => handleChange('expiresAt', e.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          <div className="hc-actions">
            <button type="submit" className="hc-btn hc-btn-primary" disabled={loading}>
              <svg className="hc-icon-plus" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M12 5v14M5 12h14"/>
              </svg>
              {loading ? 'Erstelle…' : 'Erstellen'}
            </button>
            <button type="button" className="hc-btn hc-btn-ghost" onClick={onClose}>
              Abbrechen
            </button>
          </div>
        </form>

      </div>
    </div>
  );
}
